import { lazyLoad } from 'utils/loadable';

export const SeoSettings = lazyLoad(() => import('./index'));
